const buildModalMarkup = () => `
  <div class="contact-modal__backdrop" data-contact-modal-close></div>
  <div class="contact-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="contact-modal-title" tabindex="-1" data-lenis-prevent data-lenis-prevent-wheel data-lenis-prevent-touch>
    <button type="button" class="contact-modal__close" data-contact-modal-close aria-label="Fechar modal">×</button>
    <div class="contact-modal__content">
      <h2 class="contact-modal__title" id="contact-modal-title">Fale com a RV+</h2>
      <p class="contact-modal__description">Preencha o formulário abaixo e nossa equipe retorna o contato.</p>
      <div class="contact-modal__form">
        <script src="https://js.hsforms.net/forms/embed/45126382.js" defer></script>
        <div class="hs-form-frame" data-region="na1" data-form-id="b57a4b4b-95df-4458-a99b-0f8218d06961" data-portal-id="45126382"></div>
      </div>
    </div>
  </div>
`;

const ensureModal = () => {
  let existingModal = document.querySelector('[data-contact-modal]');
  if (existingModal) {
    return existingModal;
  }

  existingModal = document.createElement('div');
  existingModal.className = 'contact-modal';
  existingModal.setAttribute('data-contact-modal', '');
  existingModal.hidden = true;
  existingModal.setAttribute('aria-hidden', 'true');
  existingModal.innerHTML = buildModalMarkup();
  document.body.appendChild(existingModal);
  return existingModal;
};

const modal = ensureModal();

if (modal) {
  const openButtons = document.querySelectorAll('[data-contact-modal-open]');
  const closeButtons = modal.querySelectorAll('[data-contact-modal-close]');
  const dialog = modal.querySelector('.contact-modal__dialog');
  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'textarea:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(',');

  let lastFocusedElement = null;

  const getFocusableElements = () => Array.from(modal.querySelectorAll(focusableSelector))
    .filter((element) => element.offsetParent !== null || element === document.activeElement);

  const closeMobileMenu = () => {
    const hamburger = document.querySelector('.header__hamburger[aria-expanded="true"]');
    if (hamburger) {
      hamburger.click();
    }
  };

  const lockScroll = () => {
    document.body.classList.add('contact-modal-open');
  };

  const unlockScroll = () => {
    document.body.classList.remove('contact-modal-open');
  };

  const focusFirstElement = () => {
    const focusableElements = getFocusableElements();
    const target = focusableElements[0] || dialog || modal;
    if (target && typeof target.focus === 'function') {
      target.focus({ preventScroll: true });
    }
  };

  const openModal = () => {
    lastFocusedElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    closeMobileMenu();
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    lockScroll();
    window.requestAnimationFrame(() => {
      modal.classList.add('is-open');
      focusFirstElement();
    });
  };

  const closeModal = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    modal.hidden = true;
    unlockScroll();

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus({ preventScroll: true });
    }
  };

  window.abrirModal = openModal;
  window.fecharModal = closeModal;

  const hubspotScriptId = 'rv-hubspot-contact-form-script';
  if (!document.getElementById(hubspotScriptId)) {
    const script = document.createElement('script');
    script.id = hubspotScriptId;
    script.src = 'https://js.hsforms.net/forms/embed/45126382.js';
    script.defer = true;
    document.head.appendChild(script);
  }

  openButtons.forEach((button) => {
    button.addEventListener('click', openModal);
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeModal);
  });

  modal.addEventListener('click', (event) => {
    if (event.target === modal || event.target.matches('[data-contact-modal-close]')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });
}
